import type { ImportedDocumentPayload } from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';

export type ImportedDocumentRenamedAction = {
	type: 'IMPORTED_DOCUMENT_RENAMED';
	payload: ImportedDocumentPayload;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: ImportedDocumentPayload,
	typeKey: string,
	subjectId: number,
): ImportedDocumentRenamedAction => ({
	type: 'IMPORTED_DOCUMENT_RENAMED',
	payload,
	typeKey,
	subjectId,
});
